import gsap from "gsap";

export default class ModalPhotos {
    constructor(photoEditor) {
        this.modal = document.querySelector('#modal-photos');
        if (!this.modal) return; // Exit if modal is not present

        this.closeButton = document.querySelector('#close-modal-photos-btn');
        this.backButton = document.querySelector('#back-modal-photos-btn');
        this.printBtn = document.querySelector('#send-to-print-btn');
        this.photosList = document.querySelector('#photos-list');
        this.photosCartForm = document.querySelector('#photos-cart-form');
        this.photosJsonField = document.querySelector('#photos-json');
        this.photoEditor = photoEditor;
        
        // Usar la instancia de LottieLoader de PhotoEditor
        this.lottieLoader = null;

        this.init();
    }

    init() {
        this.closeButton.addEventListener('click', (e) => this.close(e));
        this.backButton.addEventListener('click', (e) => this.close(e));
        this.printBtn.addEventListener('click', (event) => this.handlePrint(event));
        this.setTL();
        
        // Obtener referencia a la instancia de LottieLoader de PhotoEditor
        this.lottieLoader = this.photoEditor.lottieLoader;
        
        // Escuchar el evento 'ESC' para cerrar el modal
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.isOpen()) {
                this.close(event);
            }
        });
    }


    async handlePrint(event) {
        event.preventDefault(); // Prevenir el envío del formulario por defecto
        try {
            // Llamar a uploadPhotosWithProgress para subir las fotos editadas
            const photoIds = await this.uploadPhotosWithProgress();
            // Guardar los IDs de las fotos en el campo oculto
            console.log("return photoIds", photoIds)
            const files = this.photoEditor.pond.getFiles();
            this.photosJsonField.value = files.map(file => { return file.serverId });
            console.log("photosJsonField", this.photosJsonField.value)
            // Enviar el formulario
            this.photosCartForm.submit();
        } catch (error) {
            this.photoEditor.showAlert(`Error al subir las fotos: ${error}`);
        }
    }

    async uploadPhotosWithProgress() {
        const pond = this.photoEditor.pond;
        const files = pond.getFiles();
        const progressContainer = document.querySelector('#upload-progress-container');
        
        // Mostrar la animación Lottie al iniciar el proceso
        this.photoEditor.showLottieAnimation();
        console.log('Modal: Starting upload process with Lottie');
        
        // Mostrar el contenedor del progreso
        progressContainer.style.display = 'block';
        
        try {
            await pond.processFiles();
            
            // Ocultar la animación Lottie cuando se complete todo el proceso
            setTimeout(() => {
                this.photoEditor.hideLottieAnimation();
                console.log('Modal: Upload process completed');
            }, 1000); // Delay para mostrar que se completó
            
            progressContainer.style.display = 'none';
            
            const photoIds = files.map(file => { return file.serverId });
            console.log("after try photoIds", photoIds)
            return photoIds;
        } catch (error) {
            // Ocultar la animación Lottie en caso de error
            this.photoEditor.hideLottieAnimation();
            console.log('Modal: Upload process error');
            throw new Error('Error al subir las fotos');
        }
    }

    showLottieAnimation() {
        if (this.lottieLoader) {
            this.lottieLoader.show();
        }
    }

    hideLottieAnimation() {
        if (this.lottieLoader) {
            this.lottieLoader.hide();
        }
    }

    close(e) {
        if (!this.isOpen()) return; // No hacer nada si el modal no está abierto
        if (e) e.preventDefault();
        document.body.removeAttribute('style'); // Eliminar el estilo de overflow
        return this.tl.duration(.45).reverse();
    }

    setTL() {
        this.tl = gsap.timeline({
            paused: true
        });
        this.tl.set(this.modal, {
            y: 30
        })
        this.tl.to("#select-photos-section", {
            duration: 0.6,
            opacity: 0,
            y: -30,
            ease: 'power2.out'
        }, 0);
        this.tl.to(this.modal, {
            duration: 0.45,
            opacity: 1,
            y: 0,
            display: 'flex',
            ease: 'power2.out'
        }, 0.2);
        this.tl.to("#modal-photos-container", {
            duration: 0.45,
            opacity: 1,
            y: 0,
            ease: 'power2.out'
        }, 0.3);
    }

    open() {
        if (this.isOpen()) return; // No hacer nada si el modal ya está abierto
        document.body.style.overflow = 'hidden';
        // Renderizar las previsualizaciones de las fotos seleccionadas
        this.renderPhotoPreviews();

        return this.tl.duration(.65).play();
    }

    isOpen() {
        return this.modal.style.display === 'flex';
    }

    renderPhotoPreviews() {
        // Limpiar la lista de fotos antes de renderizar
        this.photosList.innerHTML = '';

        // Obtener las fotos seleccionadas desde FilePond
        const selectedFiles = this.photoEditor.selectedFiles;

        selectedFiles.forEach((file) => {
            const poster = file.getMetadata().poster;
            const itemContainer = this.createPhotoItem(file.id, poster, file.file.name, file.file.size);
            this.photosList.appendChild(itemContainer);
        });
    }

    createPhotoItem(fileId, previewUrl, fileName, fileSize) {
        const itemContainer = document.createElement('div');
        itemContainer.classList.add('photo-item', 'flex', 'items-center', 'justify-left', 'gap-2');
        itemContainer.dataset.fileId = fileId;

        const imgElement = document.createElement('img');
        imgElement.src = previewUrl;
        imgElement.width = 100;
        imgElement.classList.add('preview');
        imgElement.alt = 'Previsualización de la imagen';

        const infoContainer = document.createElement('div');
        infoContainer.classList.add('text-left', 'text-xs');

        const fileNameElement = document.createElement('p');
        fileNameElement.classList.add('m-0', 'p-0', 'w-full');
        fileNameElement.textContent = fileName;

        const fileMessagesElement = document.createElement('strong');
        fileMessagesElement.classList.add('file-messages');

        const fileSizeElement = document.createElement('span');
        fileSizeElement.classList.add('file-size');
        fileSizeElement.textContent = `${(fileSize / (1024 * 1024)).toFixed(2)}mb`;

        fileMessagesElement.appendChild(fileSizeElement);

        const progressBar = document.createElement('div');
        progressBar.classList.add('progress', 'w-10', 'h-1', 'bg-petrol', 'absolute', '-bottom-1', 'left-0');
        fileMessagesElement.appendChild(progressBar);

        infoContainer.appendChild(fileNameElement);
        infoContainer.appendChild(fileMessagesElement);

        itemContainer.appendChild(imgElement);
        itemContainer.appendChild(infoContainer);

        return itemContainer;
    }
}